import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { X, Trash2 } from 'lucide-react';

interface PortfolioBulkSelectionBarProps {
  selectedCount: number;
  isMobile: boolean;
  onClearSelection: () => void;
  onBulkDeleteClick: () => void;
}

export function PortfolioBulkSelectionBar({
  selectedCount,
  isMobile,
  onClearSelection,
  onBulkDeleteClick,
}: PortfolioBulkSelectionBarProps) {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-3 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3">
          <Badge variant="secondary" className="bg-primary/20 text-primary w-fit">
            {selectedCount} allocation{selectedCount !== 1 ? 's' : ''} selected
          </Badge>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-8 px-2 text-muted-foreground hover:text-foreground w-fit min-h-[44px] sm:min-h-[32px]"
          >
            <X className="h-4 w-4 mr-1" />
            {isMobile ? 'Clear Selection' : 'Clear'}
          </Button>
        </div>
        
        <Button
          variant="destructive"
          size="sm"
          onClick={onBulkDeleteClick}
          className="gap-2 w-full sm:w-auto min-h-[44px] sm:min-h-[32px]"
        >
          <Trash2 className="h-4 w-4" />
          {isMobile ? 'Remove Selected' : 'Remove'}
        </Button>
      </div>
    </div>
  );
}
